import { getMessageSubscriber as _getMessageSubscriber } from '@/websocket/subscribers/legacy/main.websocket.subscriber.js'
import { isDeprecatedWSMessage } from './nextback.logic'

export const getMessageSubscriber = (type) => {
  return (doc, rootComponent) => {
    if (!isDeprecatedWSMessage(doc, rootComponent)) {
      return _getMessageSubscriber(type)(doc, rootComponent)
    }
    return null
  }
}
